export function isBoolean(v) {
  return typeof v === "boolean";
}
